const crops = {
    crops: {
        "1": "Melancia",
        "2": "Abóbora de Verão",
        "3": "Courgette",
        "4": "Cana de Açúcar",
        "5": "Pepino para pickles",
        "6": "Maças",
        "7": "Aipo",
        "8": "Damasco",
        "9": "Aipo verde outono",
        "10": "Cebolinho - 1.º ano",
        "11": "Cebolinho - 2.º ano",
        "12": "Cenouras lavadas",
        "13": "Batata doce",
        "14": "Milho (silagem 67% água)",
        "15": "Pêssegos",
        "16": "Batatas",
        "17": "Cebola de primavera",
        "18": "Alho",
        "19": "Couve crespa",
        "20": "Morangos",
        "21": "Beterraba",
        "22": "Brócolis",
        "23": "Couves de Bruxelas",
        "24": "Aipo-branqueado outono",
        "25": " Beterraba",
        "26": "Cenoura inverno",
        "27": "Tomates",
        "28": "Cebola inverno",
        "29": "Uvas (mesa)",
        "30": "Alface - cabeça Verão",
        "31": "Salsa",
        "32": "Alface - oakleaf Verão",
        "33": "Alface oakleaf",
        "34": "Topinambur Alcachofra Jerusalém",
        "35": "Ameixas",
        "36": "Meloa",
        "37": "Óleo de palma",
        "38": "Alface",
        "39": "Kiwi",
        "40": "Couve roxa",
        "41": "Peras",
        "42": "Banana",
        "43": "Endivas escarola - Verão",
        "44": "Endivas escarola - baby",
        "45": "Endivas folha frisada",
        "46": "Couve - armazenagem comum",
        "47": "Alho-poró Verão",
        "48": "Alho-poró outono inverno",
        "49": "Morango perpétuo",
        "50": "Papaia",
        "51": "Espinafre",
        "52": "Tomate indústria",
        "53": "Abóbora",
        "54": "Chicória",
        "55": "Couve",
        "56": "Beringela",
        "57": "Couve Primavera",
        "58": "Couve savoy",
        "59": "Couve verde savoy",
        "60": "Feijão comum",
        "61": "Laranjas",
        "62": "Chalota vermelha",
        "63": "Melão",
        "64": "Tabaco (flue)",
        "65": "Tabaco (burley)",
        "66": "Café",
        "67": "Cevada (primavera)",
        "68": "Trigo 10% proteína",
        "69": "Trigo 12% proteína",
        "70": "Trigo 14% proteína",
        "71": "Milho (grão)",
        "72": "Girassol",
        "73": "Arroz",
        "74": "Sorgo (grão)",
    },
};
export default crops;
